import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { InHomeUtils } from './../util/inhomeUtils';

class promoCart extends React.PureComponent {
    render() {
        let template;
        if (InHomeUtils.isNotNull(this.props.disclaimerFragment) && InHomeUtils.isNotEmpty(this.props.disclaimerFragment.promo)  && this.props.disclaimerFragment.promo !== "<p>N/A</p>"){    
            if(InHomeUtils.isNotEmpty(this.props.disclaimerFragment.location) && this.props.disclaimerFragment.location.substring(0,3) === this.props.locationId) {
                template = <li className=""></li>;
                template = <p className="margin-bottom-zero"> {ReactHtmlParser(this.props.disclaimerFragment.promo)}</p>
            }
        }

        return (
            <React.Fragment>
              {template}
           </React.Fragment>
        )
    }
}
export default promoCart;